import React, { useContext, useEffect, useState } from 'react'
import LogContext from '../../context/LogContext';
import profileLogo from '../../media/user.png';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import axios from 'axios';
import { accountScroll } from '../../utils/accountScroll';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
export default function ProfileInfo() {
  const navigate = useNavigate();
  const myContext = useContext(LogContext);
  const [edit1, setEdit1] = useState(true);
  const [edit2, setEdit2] = useState(true);
  const [edit3, setEdit3] = useState(true);
  const [user, setUser] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [gender, setGender] = useState();
  const [mobile, setMobile] = useState();
  const [prevFirstName, setPrevFirstName] = useState();
  const [prevLastName, setPrevLastName] = useState();
  const [prevGender, setPrevGender] = useState();
  const [prevMobile, setPrevMobile] = useState();
  const [email, setEmail] = useState();
  const [inputFirstName, setInputFirstName] = useState(myContext.user.firstName);
  const [inputLastName, setInputLastName] = useState(myContext.user.lastName);
  const [inputGender, setInputGender] = useState(myContext.user.gender);
  const [inputMobile, setInputMobile] = useState(myContext.user.mobile);
  const { isAuthenticated, loading } = useAuth();
  const handelSave = async (type) => {
    setFirstName(inputFirstName);
    setLastName(inputLastName);
    setGender(inputGender);
    setMobile(inputMobile);
    try {
      if (type === "personal") {
      const response = await fetch(`${backendUrl}/savePersonalInfo`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ firstName, lastName, gender, type, email })
      });
      if (response.ok) {
        // console.log("saved successfully");
        setEdit1(true);
        const edit1 = document.getElementById('edit1');
        edit1.textContent = "Edit"
      }
      else if (type === "mobile") {
        // console.log("unable to save")
      }
    }
    else {
      // console.log("save mobile");
      const response = await fetch(`${backendUrl}/savePersonalInfo`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ mobile, type, email })
      });
      if (response.ok) {
        // console.log("saved successfully");
        setEdit3(true);
        const edit3 = document.getElementById('edit3');
        edit3.textContent = "Edit"

      }
      else {
        console.log("unable to save")
      }
    }
    } catch (error) {
      console.log("Some error occured", error);
    }
    
  }

  const handleChange = (e) => {
    setGender(e.target.value);
    setInputGender(e.target.value);
  };

  const handleEdit = (e, field) => {
    setFirstName(inputFirstName);
    setLastName(inputLastName);
    setGender(inputGender);
    setMobile(inputMobile);
    if (field === "edit1" && e.target.textContent === "Edit") {
      setEdit1(false);
      e.target.textContent = "Cancel"
    }
    else if (field === "edit2" && e.target.textContent === "Edit") {
      setEdit2(false);
      e.target.textContent = "Cancel"
    }
    else if (field === "edit3" && e.target.textContent === "Edit") {
      setEdit3(false);
      e.target.textContent = "Cancel"
    }
    else if (field === "edit1" && e.target.textContent === "Cancel") {
      setEdit1(true);
      setFirstName(prevFirstName);
      setLastName(prevLastName);
      setGender(prevGender);
      e.target.textContent = "Edit";
    }
    else if (field === "edit3" && e.target.textContent === "Cancel") {
      setEdit3(true);
      setInputMobile(prevMobile)
      e.target.textContent = "Edit"
    }
  }

  const getAccountInfo = async () => {
    try {
      const response = await fetch(`${backendUrl}/getPersonalInfo`, {
      method: 'POST',
      headers: {
        'content-type': "application/json"
      },
      body: JSON.stringify({ email: myContext.user.email })
    });
    if (response.ok) {
      const data = await response.json();
      setInputFirstName(data["user"].firstName);
      setInputLastName(data["user"].lastName);
      setInputGender(data["user"].gender);
      setInputMobile(data["user"].mobile);
    }
    } catch (error) {
        console.log("Some error occured", error)
    }
  }
  const handelLogout = async () => {
   try {
     const response = await axios.get(`${backendUrl}/logout`, {
      credentials: true // Include cookies in the request
    });
    navigate('/', { replace: true });
    setTimeout(() => {
      window.location.reload();
    }, 0);
   } catch (error) {
    console.log("Sme error occured", error)
   }
  }

  const handleScroll = () => {
    if (window.innerWidth <= 576) {
      accountScroll('account-scroll');
    }
  }
  useEffect(() => {
    getAccountInfo();
    setPrevFirstName(inputFirstName);
    setPrevLastName(inputLastName);
    setPrevGender(inputGender);
    setPrevMobile(inputMobile);
    setEmail(myContext.user.email);
  }, [myContext]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.innerWidth <= 576) {
        accountScroll('account-scroll');
      }
    }, 100); // You might increase this to 300ms if DOM isn't fully ready

    return () => clearTimeout(timer); // cleanup in case the component unmounts quickly
  }, []);


  return (


    <div className='profile'>
      <div className='row'>
        <div className='col-sm-4 col-xs-12' style={{ marginBottom: '2rem' }}>
          <div style={{ display: 'flex' }} className='hello'>
            <img src={profileLogo} alt="" />
            {/* <p className='hello-text'>Hello !</p> */}
            <p className='name-text'>{inputFirstName} {inputLastName}</p>
          </div>
          <div className='profile-list'>
            <p className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/orders'); handleScroll() }} ><i className="fa-solid fa-bag-shopping"></i> <span className='head'>Orders</span> <hr /></p>
            <ul className='account-settings'>
              <li className='list-item'><i className="fa-solid fa-user" ></i><span className='head'> Account Settings</span></li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/personal-info'); handleScroll() }}>Personal Information</li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/addresses'); handleScroll() }}>Manage Addresses</li>
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>PAN Card Information<hr /></li> */}

            </ul>
            <ul>
              <li className='list-item'><i className="fa-solid fa-briefcase"></i> <span className='head'>My Stuff</span></li>
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Copouns</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Reviews & Ratings</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>All Notifications</li> */}
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/wishlist'); handleScroll() }}>My Whitlist<hr /></li>

            </ul>
            <div id='account-scroll'>
              <p className='list-item' style={{ cursor: "pointer" }} onClick={handelLogout}><i className="fa-solid fa-right-from-bracket"></i> Logout</p>
            </div>
          </div>
        </div>
        <div className='col-sm-8 col-xs-12' >
          <div style={{ background: "white" }}>
            <p className='head1' >Personal information <span className='edit' id='edit1' onClick={(e) => { handleEdit(e, "edit1") }}>Edit</span></p>
            <input className='input edit1' type="text" name="first" value={inputFirstName} placeholder='First Name' disabled={edit1} onChange={(e) => { setFirstName(e.target.value); setInputFirstName(e.target.value) }} />
            <input className='input edit1' type="text" name="last" value={inputLastName} placeholder='Last Name' disabled={edit1} onChange={(e) => { setLastName(e.target.value); setInputLastName(e.target.value) }} />
            {!edit1 && <button className='save-btn' onClick={() => { handelSave('personal') }}>Save</button>}
            <p className='content'>
              Your Gender
            </p>
            <form className="form" style={{ display: "flex" }}>
              <div className='radio-male'>
                <label>
                  <input
                    className='edit1'
                    type="radio"
                    name="gender"
                    value="male"
                    checked={inputGender === 'male'}
                    onChange={handleChange}
                    disabled={edit1}
                  />
                  &nbsp;&nbsp;Male
                </label>
              </div>
              <div className='radio-female'>
                <label>
                  <input
                    className='edit1'
                    type="radio"
                    value="female"
                    name="gender"
                    checked={inputGender === 'female'}
                    onChange={handleChange}
                    disabled={edit1}
                  />
                  &nbsp;&nbsp;Female
                </label>
              </div>
            </form>
            <p className='head2'>Email Address </p>
            <input className='input edit2' type="text" name="email" value={myContext.user ? myContext.user.email : ""} placeholder='Email' disabled={edit2} />
            <p className='head2'>Mobile Number <span className='edit' id="edit3" onClick={(e) => { handleEdit(e, "edit3") }}>Edit</span></p>
            <input className='input edit3' id="input3" type="text" name="mobile" value={inputMobile} placeholder='Mobile' disabled={edit3} onChange={(e) => { setMobile(e.target.value); setInputMobile(e.target.value) }} />
            {!edit3 && <button className='save-btn' onClick={() => { handelSave('mobile') }}>Save</button>}

            <div className='faq'>
              <p className='head'>FAQs</p>
              <p className='ques'>
                What happens when I update my email address (or mobile number)?
              </p>
              <p className='ans'>
                Your login email id (or mobile number) changes, likewise. You'll receive all your account related communication on your updated email address (or mobile number).
              </p>
              {/* <p className='ques'>
                When will my Kidorise account be updated with the new email address (or mobile number)?            
                </p>
              <p className='ans'>
                It happens as soon as you confirm the verification code sent to your email (or mobile) and save the changes.            
                </p> */}
              <p className='ques'>
                What happens to my existing Kidorise account when I update my email address (or mobile number)?            </p>
              <p className='ans'>
                Updating your email address (or mobile number) doesn't invalidate your account. Your account remains fully functional. You'll continue seeing your Order history, saved information and personal details.            </p>
              {/* <p className='ques'>
                Does my Seller account get affected when I update my email address?
              </p> */}
              {/* <p className='ans'>
                has a 'single sign-on' policy. Any changes will reflect in your Seller account also.
              </p> */}
            </div>
            {/* <div className='account'>
              <p className='deactivate'>Deactivate Account</p>
              <p className='delete'>Delete Account</p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
